var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMediaTwitter = function SvgMediaTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#25A0EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29 14.008a7.646 7.646 0 0 1-2.284 1.228c-.897-1.138-2.343-1.537-3.62-1-1.277.538-2.114 1.898-2.096 3.406v.802c-2.596.075-5.053-1.29-6.546-3.634 0 0-2.909 7.22 3.637 10.429-1.498 1.121-3.282 1.683-5.091 1.604 6.546 4.011 14.546 0 14.546-9.225-.001-.223-.02-.446-.059-.666A6.38 6.38 0 0 0 29 14.008Z"
  })));
};
export default SvgMediaTwitter;